/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class ValidationService {
	private validationMessages: any;

	constructor(private translate: TranslateService, private ngbDateParserFormatter: NgbDateParserFormatter) {}

	getValidationMessage(validationName: string, value: any) {
		this.validationMessages = {
			required: this.translate.instant('validationMessages.required'),
			email: this.translate.instant('validationMessages.invalidEmail'),
			invalidEmail: this.translate.instant('validationMessages.invalidEmail'),
			invalidFileSize: this.translate.instant('validationMessages.invalidFileSize', {
				fileName: value.fileName,
				current: value.currentSize
			}),
			minlength: this.translate.instant('validationMessages.minLength', {
				length: value.requiredLength,
				current: value.actualLength
			}),
			maxDateToday: this.translate.instant('validationMessages.maxDateToday')
			// invalidDate: 'Fecha no valida,'
		};
		return this.validationMessages[validationName] ? this.validationMessages[validationName] : undefined;
	}

	emailValidation(control: FormControl) {
		const EMAIL_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
		return !control.value || control.value.match(EMAIL_REGEX) ? null : { invalidEmail: true };
	}

	phoneValidation(phone: string, typePhone: string) {
		const PHONE_REGEX = typePhone === '1' ? /^[89]/ : /^[67]/;
		return !phone || phone.match(PHONE_REGEX) ? null : { invalidPhone: true };
	}

	fileSizeValidation(control: FormControl) {
		const overseizedFile = control.value.find((file: File) => file.size > 1048576 * 10);
		if (overseizedFile) {
			console.error(`Hay problema de tamaño con ${overseizedFile.name}`);
		}
		return !(control.value.length > 0) || !overseizedFile
			? null
			: { invalidFileSize: { fileName: overseizedFile.name, current: '1.5MB' } };
	}

	maxDateToday(control: FormControl) {
		const fecha: NgbDateStruct = control?.value;
		const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
		return !control.value ||
			(fecha &&
				fecha.year &&
				fecha.month &&
				fecha.day &&
				new Date(fecha.year, fecha.month - 1, fecha.day) <= currentDate)
			? null
			: { maxDateToday: true };
	}
}
